import { apiURL, googleCalendarUrl } from "./variable";

const URL = {
  login: `${apiURL}/authenticate/sign_in`,
  logout: `${apiURL}/authenticate/sign_out`,
  getChannelKey: `${apiURL}/getkey`,
  e2ee_check: `${apiURL}e2ee_check`,
  storeCase: `${apiURL}/storecase`,
  tokenRefresh: `${apiURL}/refresh_token`,
  assessmentResult: `${apiURL}/assessmentresult`,
  proassessment: `${apiURL}/proassessment`,
  setAssessmentReminder: `${apiURL}/setassessmentreminder`,
  listCases: `${apiURL}/listcases`,
  cancelSession: `${apiURL}/cancel`,
  cancelSessionReason: `${apiURL}/cancellation_reason`,
  addSessionSummary: `${apiURL}/savebookingsummary`,
  updatebooking: `${apiURL}/updatebooking`,
  activeLanguages: `${apiURL}/languages/active`,
  activeDomains: `${apiURL}/domainareas/active`,
  newOtp: `${apiURL}/client/send_otp_for_phone_verification`,
  verifyOtp: `${apiURL}/client/verify_phone`,
  giveaccesstoken: `${apiURL}/giveaccesstoken`,
  passwordReset: `${apiURL}/authenticate/password`,
  activeGoals: `${apiURL}/casemeta`,
  CGIScore: `${apiURL}/providers/cgi`,
  nextSession: `${apiURL}/providers/next/session`,
  nextSessionDelete: `${apiURL}/providers/next/session/delete`,
  clientAPI: `${apiURL}/clientdetails`,
  scheduleCount: `${apiURL}/providers/activeschedulescount`,
  newScheduleCount: `${apiURL}/providers/schedules/active_schedules_count`,
  getActiveSchedulesForDate: `${apiURL}/providers/activeschedulesfordate`,
  newGetActiveSchedulesForDate: `${apiURL}/providers/schedules/active_schedules_date`,
  getChatShortcuts: `${apiURL}/providers/chat_shortcuts`,
  searchChatShortcut: `${apiURL}/providers/search/shortcuts`,
  unreadChatRoomIds: `${apiURL}/chat/rooms/get_unread_room_ids`,
  sessionServiceChanges: `${apiURL}/providers/bookings`,
  sessionsURL: `${apiURL}/providers/bookings`,
  automatedCall: `${apiURL}/reminder`,
  transactions: `${apiURL}/providers/bookings/transactions`,
  getClientDetails: `${apiURL}/providers/clients`,
  searchExperts: `${apiURL}/search/v3/<expert_type>`,
  activeClinics: `${apiURL}/customers/active_clinics`,
  chatClientList: `${apiURL}/providers/clients/list`,
  partnersForProvider: `${apiURL}/providers/couples/partners_for_provider`,
  sessionCount: `${apiURL}/cancellationpromptsessions`,
  sessionDetails: `${apiURL}/sessiondetail`,
  endSession: `${apiURL}/endsession`,
  b2bOrgHints: `${apiURL}/providers/organisations/search`,
  markJournalAsRead: `${apiURL}/bse/v2/providers/tools`,
  cfProviderSessionTypes: `${apiURL}/providers/bookings/distinct_sub_session_types`,

  // Availability and slots API
  getMonthlySchedules: `${apiURL}/providers/schedules`,
  getBaseWeekSchedules: `${apiURL}/providers/schedules/baseweek_v2`,
  saveBaseWeekSchedules: `${apiURL}/providers/schedules/save_baseweek_v2`,
  getDateWiseSlots: `${apiURL}/providers/schedules/datewise_slots_v3`,
  saveDateWiseSlots: `${apiURL}/providers/schedules/save_datewise_slots_v3`,
  resetToBaseWeek: `${apiURL}/providers/schedules/reset_baseweek`,

  offeredDuration: `${apiURL}/providers/payments/offered_durations`,
  offlineClinics: `${apiURL}/providers/ih_clinics`,

  //OAS API's
  assessmentsAndGroupTherapy: `${apiURL}/providers/ancillary_services`,
  assessmentURL: `${apiURL}/providers/psychometric_assessment_users`,
  groupTherapyURL: `${apiURL}/providers/group_therapy_batches`,

  // Session prompt API's
  getOfferedPackages: `${apiURL}/providers/payments/active_offered_durations`,
  getActiveScheduleCount: `${apiURL}/providers/schedules/active_schedules_count`,
  getAllActiveSchedules: `${apiURL}/providers/schedules/active_schedules_date`,
  getOfferedModes: `${apiURL}/providers/offered_modes`,

  //Bookings
  supervisorBookings: `${apiURL}/supervisors/providers`,
  bookingDetails: `${apiURL}/providers/bookings`,
  getPostSessionActions: `${apiURL}/providers/post_session_actions/view`,
  updatePostSessionActions: `${apiURL}/providers/post_session_actions/update_status`,
  getParticipantsDetails: `${apiURL}/providers/bookings/<booking_id>/get_customers_and_providers`,
  getAttendanceDetails: `${apiURL}/providers/bookings/<booking_id>/attendance_status`,
  markAttendanceDetails: `${apiURL}/providers/bookings/<booking_id>/mark_attendance`,

  //Therapist URLs
  clientList: `${apiURL}/providers/clients`,
  clientAppData: `${apiURL}/therapist/clientData/appData`,
  contentFeedback: `${apiURL}/therapist/clientData/content_feedback`,
  editCase: `${apiURL}/therapist/clientData/editcase`,
  therapistGoals: `${apiURL}/therapist/clientData/therapistGoals`,
  assignedAssessments: `${apiURL}/therapist/client/assignedassessments`,
  completedAssessments: `${apiURL}/therapist/client/completedassessments`,
  unassignedAssessments: `${apiURL}/therapist/client/unassignedassessments`,
  sessionsList: `${apiURL}/therapist/sessionsList`,
  assignAssessment: `${apiURL}/therapist/assignassessment`,
  unassignAssessment: `${apiURL}/therapist/unassignassessment`,
  assessmentDetail: `${apiURL}/assessmentdetail`,
  approveSession: `${apiURL}/therapist/approvedbookingstatus`,
  therapistProfile: `${apiURL}/therapist/profileinfo`,
  therapistProfileDetail: `${apiURL}/therapist/profiledetail`,
  providerApprovalBanner: `${apiURL}/providers/profile_approval_data`,
  therapistSchedules: `${apiURL}/therapist/schedules`,
  therapistMonthlySchedules: `${apiURL}/therapist/availability/slots`,
  clientAnalytics: `${apiURL}/therapist/analytics/clients`,
  sessionAnalytics: `${apiURL}/therapist/analytics/sessions`,
  feedbackAnalytics: `${apiURL}/therapist/analytics/feedbackscore`,
  repeatRatioAnalytics: `${apiURL}/therapist/analytics/repeatratio`,
  recommendPsychiatrist: `${apiURL}/therapist/recommendpsychiatrist`,
  resetToBaseWeekForTherapist: `${apiURL}/therapist/availability/slots/reset`,
  getMgafSessionList: `${apiURL}/therapist/getMgaf`,
  saveMgafSessionList: `${apiURL}/therapist/saveMgaf`,
  getMgafSession: `${apiURL}/therapist/checkifmgaf`,
  customers: `${apiURL}/bse/customers`,
  getToolTypeOfMedia: `${apiURL}/bse/tool_types`,
  customGNToolsQuestion: `${apiURL}/bse/search/questions`,
  saveNewTemplate: `${apiURL}/bse/tools`,
  getTreatmentMethods: `${apiURL}/providers/treatment_methods`,
  providerSessionStarted: `${apiURL}/bookings`,
  bseTools: `${apiURL}/bse/tools`,

  //Psychiatrist URLs
  psychiatristClientList: `${apiURL}/psychiatrist/clientList`,
  psychiatristSessionsList: `${apiURL}/psychiatrist/sessionsList`,
  psychiatristProfile: `${apiURL}/psychiatrist/profileinfo`,
  psychiatristProfileDetail: `${apiURL}/psychiatrist/profiledetail`,
  psychiatristSchedules: `${apiURL}/psychiatrist/schedules`,
  psychiatristMonthlySchedules: `${apiURL}/psychiatrist/availability/slots`,
  psychiatristClientAnalytics: `${apiURL}/psychiatrist/analytics/clients`,
  psychiatristSessionAnalytics: `${apiURL}/psychiatrist/analytics/sessions`,
  psychiatristFeedbackAnalytics: `${apiURL}/psychiatrist/analytics/feedbackscore`,
  psychiatristRepeatRatioAnalytics: `${apiURL}/psychiatrist/analytics/repeatratio`,
  psychiatristCompletedAssessments: `${apiURL}/psychiatrist/client/completedassessments`,
  recommendTherapist: `${apiURL}/psychiatrist/recommendtherapist`,
  medications: `${apiURL}/psychiatrist/medications`,
  diseases: `${apiURL}/psychiatrist/diseases`,
  prescriptions: `${apiURL}/psychiatrist/getPrescriptions`,
  savePrescriptions: `${apiURL}/psychiatrist/savePrescription`,

  getClientPreviousPrescriptions: `${apiURL}/providers/customers/<client_id>/prescriptions/prescription_medicines_history`,
  getPaginatedPrescriptions: `${apiURL}/psychiatrist/getPrescriptions`,
  getClientIdentity: `${apiURL}/getidentity`,
  diagnosis: `${apiURL}/diagnosis`,
  disgnosisList: `${apiURL}/psychiatrist/getDiagnoses`,
  saveDiagnosis: `${apiURL}/psychiatrist/saveDiagnosis`,
  updateDiagnosis: `${apiURL}/psychiatrist/updateDiagnosis`,
  psychiatristBookSession: `${apiURL}/psychiatrist/sessions`,
  resetToBaseWeekForPsychiatrist: `${apiURL}/psychiatrist/availability/slots/reset`,

  // Package Urls
  uploadIntakeReport: `${apiURL}/providers/intake_reports`,
  autoFillStatus: `${apiURL}/providers/intake_reports/auto_fill_status`,

  //Ehr URls
  getEhrBookingRecordedStatus: `${apiURL}/providers/electronic_health_records/booking_recorded_status`,
  getEhr: `${apiURL}/providers/electronic_health_records/get_details`,
  submitEhr: `${apiURL}/providers/electronic_health_records`,
  improveEhrField: `${apiURL}/providers/electronic_health_records`,
  getSessionRecordedStatus: `/providers/intake_reports/is_session_recorded`,
  retryAiGeneration: `/providers/electronic_health_records/<ehr_id>/retry`,

  sessionApproval: `${apiURL}/therapist/approvedbookingstatus`,

  //Between Session Notes
  fetchAllNotes: `${apiURL}/providers/notes`,
  viewSubmittedNotes: `${apiURL}/providers/notes/view`,

  //BSE Modal
  toolTypes: `${apiURL}/bse/v2/providers/tool_types`,
  searchTools: `${apiURL}/bse/search/tools`,
  bseMetaInfo: `${apiURL}/bse/v2/providers/meta_infos`,
  saveMetaInfo: `${apiURL}/bse/v2/providers/meta_infos/save_metainfo`,
  mostCompletedTools: `${apiURL}/bse/v2/providers/meta_infos/most_completed_tools`,
  lastThreeTools: `${apiURL}/bse/v2/providers/meta_infos/last_three_tools`,
  toolsHistory: `${apiURL}/bse/v2/providers/tools/history`,
  favoriteTools: `${apiURL}/bse/v2/providers/favourites`,
  allTools: `${apiURL}/bse/v2/providers/tool_templates`,
  customToolTypes: `${apiURL}/bse/v2/providers/tool_types/custom`,
  suggestedTools: `${apiURL}/bse/v2/providers/tool_templates/suggestions`,
  markFavorite: `${apiURL}/bse/v2/providers/favourites/mark`,
  unMarkFavorite: `${apiURL}/bse/v2/providers/favourites/unmark`,
  notifications: `${apiURL}/providers/notifications`,
  bseConcerns: `${apiURL}/providers/domainareas`,
  assignedOnDates: `${apiURL}/bse/v2/providers/meta_infos/assigned_on_dates`,
  providers: `${apiURL}/providers/customers`,
  psychiatrist: `${apiURL}/psychiatrist`,
  updateAiTooltipViewed: `${apiURL}/providers/mark_ai_modal_viewed`,

  // Supervision
  getProvidersList: `${apiURL}/supervisors/providers_list`,
  getProvidersRoles: `${apiURL}/supervisors/provider_roles`,
  getProviderDetails: `${apiURL}/supervisors/provider_details`,
  getSuperviseeInitialAssessments: `${apiURL}/supervisors/providers/<provider_id>/clients/<client_id>/completed_assessments`,
  getSuperviseeTools: `${apiURL}/supervisors/providers/<provider_id>/clients/<client_id>/timeline`,
  getRiskManagerSupervisees: `${apiURL}/supervisors/risk_managers/supervisees`,

  // Provider Tagging
  getTherapists: `${apiURL}/alltherapists`,
  getCareCoordinators: `${apiURL}/allproviders?version=2&role=care-coordinator`,
  getPsychiatrists: `${apiURL}/allpsychiatrists`,
  getAllProviders: `${apiURL}/allproviders`,
  getAssessmentNames: `${apiURL}/psychometric_assessments`,
  customerAddonServices: `${apiURL}/customer_addon_service_mappings`,
  getAssessmentCategories: `${apiURL}/psychometric_assessment_types`,
  getUpdateHistory: `${apiURL}/providers/provider_tagging_logs/list`,
  getUpdateHistoryV2: `${apiURL}/providers/provider_tagging_logs/list_v2`,

  // Provider History
  getProviderTaggingLogs: `${apiURL}/providers/provider_tagging_logs`,

  // Note Sharing
  getPrivateNotes: `${apiURL}/providers/notes/share_list`,
  getProvidersForSharingNotes: `${apiURL}/customer_provider_mappings`,
  shareNotes: `${apiURL}/providers/notes/share`,

  // Analytics
  clientSessions: `${apiURL}/providers/twa_analytics/client_sessions`,
  clientFollowup: `${apiURL}/providers/twa_analytics/client_sessions_data`,
  averageSessions: `${apiURL}/providers/twa_analytics/client_average_sessions`,
  sessionSummary: `${apiURL}/providers/twa_analytics/client_sessions_summary`,
  clientFeedback: `${apiURL}/providers/twa_analytics/client_feedback`,
  otherInformation: `${apiURL}/providers/twa_analytics/client_other_informations`,
  intakeReportStatus: `${apiURL}/providers/twa_analytics/intake_report_status`,
  notesStatus: `${apiURL}/providers/twa_analytics/notes_status`,
  mgafRatingStatus: `${apiURL}/providers/twa_analytics/mgaf_rating_status`,
  cgiRatingStatus: `${apiURL}/providers/twa_analytics/cgi_rating_status`,
  ageDistribution: `${apiURL}/providers/twa_analytics/age_distribution`,
  riskAssessmentMetrics: `${apiURL}/providers/twa_analytics/risk_assessment_metrics`,
  // diagnosisAnalysis: `${apiURL}/providers/twa_analytics/diagnosis_analysis`,
  // diagnosisClientDetails: `${apiURL}/providers/twa_analytics/diagnosis_client_details`,
  timeUtilisation: `${apiURL}/providers/twa_analytics/time_utilization`,
  clientFeedbackV2: `${apiURL}/providers/twa_analytics/client_feedback_v2`,
  delightPanel: `${apiURL}/providers/twa_analytics/delight_panel`,

  // Sick Flow
  availabilityChanges: `${apiURL}/providers/provider_availability_changes`,
  getRepeatOnValuesByDate: `${apiURL}/providers/provider_availability_changes/repeat_on_values`,
  getBookedSlotsTimeline: `${apiURL}/providers/provider_availability_changes/booked_slots_timeline`,

  getAssignedLocations: `${apiURL}/providers/ih_clinics/me`,

  helpAndUpdates: `${apiURL}/providers/twa_updates`,

  // Concerns
  addConcerns: `${apiURL}/providers/customers/<client_id>/provider_customer_concerns`, //post
  getConcernsHistory: `${apiURL}/providers/customers/<client_id>/provider_customer_concerns`, //get
  getConcernsList: `${apiURL}/providers/domainareas/organisation_concerns`,

  // Calendar
  gauth: `${apiURL}/gauth`,
  calendarEvents: `${googleCalendarUrl}/calendars/primary/events`,
  authToken: "https://oauth2.googleapis.com/token",
  revokeConsent: "https://accounts.google.com/o/oauth2/revoke",
  blockedTime: `${apiURL}/providers/calendar_accounts/blocked_slots`,
  linkedAccounts: `${apiURL}/providers/calendar_accounts/linked_accounts`,
  addAccount: `${apiURL}/providers/calendar_accounts/add_account`,
  updateAccount: `${apiURL}/providers/calendar_accounts/update_account`,
  removeAccount: `${apiURL}/providers/calendar_accounts/remove_account`,

  assistant: `${apiURL}/providers/customers/<customer_uuid>/gemini/assistant`,

  // Informed Consent
  getLatestSessionNumber: `${apiURL}/providers/bookings/latest_session_number`,

  // Merge Accounts
  updateMergeAlert: `${apiURL}/providers/merge_account_provider_alerts/update_merge_alert`,
  decodeSecureToken: `${apiURL}/providers/provider_token/decode_token`,

  // Feature Flags
  featureFlags: `${apiURL}/features`,

  // Provider Tagging Hygiene
  userTabStatus: `${apiURL}/providers/clients/user_tab_status`,
  updateTabStatus: `${apiURL}/providers/clients/update_tab_status`,
  getReports: `${apiURL}/providers/clients/reports`,
  showReport: `${apiURL}/providers/clients/show_report`,
  getMgafRating: `${apiURL}/providers/clients/mgaf_rating`,
  getCgiRating: `${apiURL}/providers/clients/cgi_rating`,
  getDiagnosis: `${apiURL}/providers/clients/diagnoses`,
  getPrescriptions: `${apiURL}/providers/clients/prescriptions`,
  getTools: `${apiURL}/providers/clients/timeline`,
  getInitialAssessments: `${apiURL}/providers/clients/completed_assessments`,

  // Notifications
  toggleNotificationCategory: `${apiURL}/providers/notifications/toggle_mute_notification_category`,
  pauseNotifications: `${apiURL}/providers/notifications/pause_push_notification`,
  resumeNotifications: `${apiURL}/providers/notifications/resume_push_notification`,
  getNotificationsPausedStatus: `${apiURL}/providers/notifications/get_notification_paused_status`,
  notificationPreferences: `${apiURL}/providers/notifications/notification_category_list_with_provider_preference`,

  // Groups
  groupsList: `${apiURL}/providers/groups`,

  // Slots
  getApplicableSessionTypes: `${apiURL}/providers/schedules/get_applicable_slots_types?applicable_on=cf`,

  // Treatment Plan
  treatmentPlans: `${apiURL}/providers/clients/treatment_plans`,

  // AI
  aiPermission: `${apiURL}/ai-permission`,
  generateSummary: `${apiURL}/generate-summary-v2`,
  aiFeatureFlag: `${apiURL}/features/ai_enabled`,
  getAISummaryStatus: `${apiURL}/generate-summary-status`,

  // Risk Assessment
  riskAssessment: `${apiURL}/providers/risk_assessments`,
  getRiskAssessmentDetails: `${apiURL}/providers/risk_assessments/get_details`,
  getRiskManagers: `${apiURL}/providers/risk_managers`,

  //TWA Insights
  clientsList: `${apiURL}/providers/provider_session_analytics/search_clients`,
  batchActions: `${apiURL}/providers/provider_session_analytics/batch_actions`,
  batchActionHistoryList: `${apiURL}/providers/twa_batch_action_histories`,
  providerSessionAnalytics: `${apiURL}/providers/provider_session_analytics`,
  filterNspClients: `${apiURL}/providers/provider_session_analytics/filter_nsp_client`,
  logMessageSent: `${apiURL}/providers/clients/log_message_sent`,
  verifyNsp: `${apiURL}/providers/nsp/verify_nsp`,
  UserBookingPreferences: `${apiURL}/providers/nsp/user_booking_preferences`,
  suggestedSessions: `${apiURL}/providers/nsp/slot_suggestions`,
  createNsp: `${apiURL}/providers/nsp`,

  // Availability
  repeatValues: `${apiURL}/providers/provider_availability_changes/repeat_on_values_v2`,
  getIntervalsForBlockedSlots: `${apiURL}/providers/provider_availability_changes/get_intervals_for_blocked_slots`,
  getBookingDetailsForBlockedSlots: `${apiURL}/providers/provider_availability_changes/booking_details_of_date`,
  createBlockedSlots: `${apiURL}/providers/provider_availability_changes/create_blocked_slots`,
  getBlockedHistory: `${apiURL}/providers/provider_availability_changes/block_history`,
  unblockSlots: `${apiURL}/providers/provider_availability_changes/unblock_slots`,
  blockedSlotsFeedback: `${apiURL}/providers/feature_feedbacks`,
  checkIfAllSlotsBlocked: `${apiURL}/providers/provider_availability_changes/all_slots_blocked`,

  // clients
  fetchB2bNotifications: `${apiURL}/providers/customers/:customer_id/b2b_notifications`,
  markB2bNotificationAsRead: `${apiURL}/providers/customers/:customer_id/b2b_notifications/:notification_id/mark_shown`,

  // Coach Calls
  coachCalls: `${apiURL}/providers/coach_calls`,
  coachCallCoupons: `${apiURL}/providers/coach_calls/coupons`,
  updateCoachCallStatus: `${apiURL}/providers/coach_calls/:id`,

  // AI Chat
  aiChatCentrifugoToken: `${apiURL}/providers/twa_ai/centrifugo/token`,
  aiChatConversations: `${apiURL}/providers/twa_ai/conversations`,
  aiChatPrompts: `${apiURL}/providers/twa_ai/prompts`,
  aiChatFeedback: `${apiURL}/providers/twa_ai/conversations/:conversation_id/chats/:chat_id/feedback`,
  aiChatReports: `${apiURL}/providers/twa_ai/conversations/:conversation_id/reports`,
  twaAINudges: `${apiURL}/providers/twa_ai/ui_events`,
  suggestedPrompts: `${apiURL}/providers/twa_ai/suggested_prompts`,
  customizationPromptValidate: `${apiURL}/providers/twa_ai/prompts/validate`,
  newAssistant: `${apiURL}/providers/gemini/assistant`,
  sessionListCentrifugoToken: `${apiURL}/centrifugo/token`,

  dismissAdvancedOptionsBanner: `${apiURL}/providers/dismiss_advanced_options_banner`,
};

export default URL;
